export default __webpack_public_path__ + "static/media/RocketDAO-Congratulations.44787ffd.svg";